import { render } from "./ModificaCollo.vue?vue&type=template&id=ddc7855c&scoped=true"
import script from "./ModificaCollo.vue?vue&type=script&lang=js"
export * from "./ModificaCollo.vue?vue&type=script&lang=js"

import "./ModificaCollo.vue?vue&type=style&index=0&id=ddc7855c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddc7855c"]])

export default __exports__